import District from "../../../components/NewInfo/District/District";
import BType from "../../../components/NewInfo/BType/Btype";
import RoomsOrPropose from "../../../components/NewInfo/RoomsOrPropose/RoomsOrPropose";
import CeilingHeight from "../../../components/NewInfo/CeilingHeight/CeilingHeight";
import Bathroom from "../../../components/NewInfo/BathRoom/Bathroom";
import { SearchData } from "../../../helpers/SearchData";
import "./search.css";
import { useState, useEffect } from "react";
import {getBrokers,getManagers} from "../../../services/Real_estate";
import AplicationStatus from "../../../components/NewInfo/Aplication_Status/AplicationStatus";
import Property from "../../../components/NewInfo/Property/Property";
import BuildingStatus from "../../../components/NewInfo/BuildingStatus/BuildingStatus";
import Street from "../../../components/NewInfo/Street/Street";
export const API_URL = process.env.REACT_APP_API_URL;

export default function Search({
  district,
  district1,
  district2,
  setDistrict,
  setDistrict1,
  setDistrict2,
  asr,
  id,
  setSearchedData,
  navigate,
  data,
  allDeleted,
}) {
  const [house, setHouse] = useState(false);
  const [land, setLand] = useState(false);
  const [appartament, setAppartament] = useState(true);
  const [commercial, setComercial] = useState(false);
  const [managers, setManagers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [brokerId, setBrokerId] = useState("");
  const [managerId, setManagerId] = useState("");
  const [isSmall] = useState(window.innerWidth <= 1470);
  const [isSmall2] = useState(window.innerWidth <= 700);
  const [isSmall3] = useState(window.innerWidth <= 450);
  const [selectedStreets, setSelectedStreets] = useState([]);

  useEffect(() => {
    getManagers().then(setManagers).catch(console.error);
    getBrokers().then(setBrokers).catch(console.error);
  }, []);

  const searchData = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const ownerPhone = formData.get("ownerPhone")?.trim();

    if (ownerPhone) {
  try {
    const res = await fetch(
      `${API_URL}/real-estate/search-by-number/${encodeURIComponent(ownerPhone)}`
    );
    if (!res.ok) {
      throw new Error(`Server error: ${res.status}`);
    }
    const searchResult = await res.json();

    setSearchedData(searchResult);
    navigate("searched");
  } catch (err) {
    console.error("SEARCH BY OWNER NUMBER ERROR:", err);
  }
  return;
}

	  // ✅ ЖДЁМ результат
    const result = await SearchData(
      asr,
      formData,
      setSearchedData,
      navigate,
      id,
      selectedStreets,
      data,
      allDeleted,
    );

    // 🔴 ЕСЛИ БЫЛ ПЕРЕХОД ПО ID — ВЫХОДИМ
    if (result === "navigated") {
      return;
    }

    if (brokerId || managerId) {
    setSearchedData((prev) =>
      prev.filter((item) => {
        const matchBroker = brokerId ? item.broker_id === Number(brokerId) : true;
        const matchManager = managerId ? item.manager_id === Number(managerId) : true;
        return matchBroker && matchManager;
      })
    );
  }

    // ✅ ТВОЯ СТАРАЯ ЛОГИКА (не ломается)
    
    navigate("searched");
  };

	
  return (
    <form className="searchform" onSubmit={searchData}>
      <div>
        <div className="search">
          <Property
            setHouse={setHouse}
            setLand={setLand}
            setAppartament={setAppartament}
            
            setComercial={setComercial}
            appartament={appartament}
          />
          
            <District
              district={district}
              setDistrict={setDistrict}
              district1={district1}
              setDistrict1={setDistrict1}
	      district2={district2}
              setDistrict2={setDistrict2}
            />
          
          {!land && <BType isSmall={isSmall} />}
          {!land && !isSmall2 && <BuildingStatus isSmall={isSmall} />}
          {!isSmall2 && <RoomsOrPropose isSmall={isSmall} land={land} />}
          {!land && !isSmall2 && <CeilingHeight isSmall={isSmall} />}
          {!land && !isSmall2 && <Bathroom isSmall={isSmall} />}
          {isSmall2 && (
            <div className="isSmall">
                
                {!land && (
                  <BuildingStatus isSmall={isSmall} />
                )}
              
                <RoomsOrPropose
                  
                  isSmall={isSmall}
                  land={land}
                />
                {!land && (
                  <CeilingHeight isSmall={isSmall} />
                )}
                {!land && <Bathroom isSmall={isSmall} />}
              
            </div>
          )}

          {!isSmall2 && (
            <div className="MinMax">
              <div className="bfsp">
                {!land && <p>{isSmall ? "ՇԻՆ․ ՀԱՐԿ" : "ՇԻՆՈՒԹՅԱՆ ՀԱՐԿ"}</p>}
                {!land && !house && <p>ՀԱՐԿ</p>}
                <p>{isSmall ? "ՇԻՆ․ ՄԱԿ." : "ՇԻՆՈՒԹՅԱՆ ՄԱԿԵՐԵՍ"}</p>
                {house && <p>{isSmall ? "ՀՈՂԻ ՄԱԿ." : "ՀՈՂԻ ՄԱԿԵՐԵՍ"}</p>}
                <p>ԳԻՆ $</p>
              </div>
              <div className="inputs">
                <div className="flex">
                  <p>ՄԻՆ</p>
                  <p>ՄԱՔՍ</p>
                </div>
                {!land && (
                  <div>
                    <input type="number" name="minBFloor" />
                    <span>-</span>
                    <input type="number" name="maxBFloor" />
                  </div>
                )}
                {!land && !house && (
                  <div>
                    <input type="number" name="minFloor" />
                    <span>-</span>
                    <input type="number" name="maxFloor" />
                  </div>
                )}

                <div>
                  <input type="number" name="minSqm" />
                  <span>-</span>
                  <input type="number" name="maxSqm" />
                </div>
                {house && (
                  <div>
                    <input type="number" name="minlFloor" />
                    <span>-</span>
                    <input type="number" name="maxlFloor" />
                  </div>
                )}
                <div>
                  <input type="number" name="minPrice" />
                  <span>-</span>
                  <input type="number" name="maxPrice" />
                </div>
		{asr[2] &&
			<div>
                  <input type="date" name="min_rent_end_date" />
                  <span>-</span>
                  <input type="date" name="max_rent_end_date" />
                </div>
		}
              </div>
            </div>
          )}
        </div>
        {isSmall2 && (
          <div className="MinMax">
            <div className="bfsp">
              {!land && <p>ՇԻՆՈՒԹՅԱՆ ՀԱՐԿ</p>}
              {!land && !house && <p>ՀԱՐԿ</p>}
            </div>
            <div className="inputs">
              {!land && (
                <div>
                  <input placeholder="ՄԻՆ" type="number" name="minBFloor" />
                  <span>-</span>
                  <input placeholder="ՄԱՔՍ" type="number" name="maxBFloor" />
                </div>
              )}
              {!land && !house && (
                <div>
                  <input placeholder="ՄԻՆ" type="number" name="minFloor" />
                  <span>-</span>
                  <input placeholder="ՄԱՔՍ" type="number" name="maxFloor" />
                </div>
              )}
            </div>
		
	    <div className="bfsp">
              <p>ՇԻՆՈՒԹՅԱՆ ՄԱԿ.</p>
              {house && <p>ՀՈՂԻ ՄԱԿ.</p>}
              <p>ԳԻՆ $</p>
            </div>

	    <div  className="inputs">
		<div>
                <input placeholder="ՄԻՆ" type="number" name="minSqm" />
                <span>-</span>
                <input placeholder="ՄԱՔՍ" type="number" name="maxSqm" />
              </div>
              {house && (
                <div>
                  <input placeholder="ՄԻՆ" type="number" name="min_land_surface" />
                  <span>-</span>
                  <input placeholder="ՄԱՔՍ" type="number" name="max_land_surface" />
                </div>
              )}
              <div>
                <input placeholder="ՄԻՆ" type="number" name="minPrice" />
                <span>-</span>
                <input placeholder="ՄԱՔՍ" type="number" name="maxPrice" />
              </div>
	    </div>	
          </div>
        )}
      </div>

      <div>
        <div className="inputsection">
          <input type="number" placeholder="ID" name="id" />

          {land && (
            <input
              style={{ borderRadius: "10px" }}
              type="number"
              placeholder={isSmall2 ? "ՀՈՂ. ՀԱՍՑԵ" : "ՀՈՂԱՏԱՐԱԾՔԻ ՀԱՍՑԵ"}
              name="land_number"
            />
          )}
          <Street district={district} district2={district2} district1={district1} selectedStreets={selectedStreets} setSelectedStreets={setSelectedStreets}/>
          {!land && !house && (
            <input
              style={{ borderRadius: "10px" }}
              type="text"
              placeholder={isSmall2 ? "ՇԻՆ. ՀԱՍՑԵ" : "ՇԻՆՈՒԹՅԱՆ ՀԱՍՑԵ"}
              name="building_number"
            />
          )}
          {house && (
            <input
              style={{ borderRadius: "10px" }}
              type="number"
              placeholder={isSmall2 ? "ՏԱՆ ՀԱՍՑԵ" : "ՏԱՆ ՀԱՍՑԵ"}
              name="house_number"
            />
          )}
          {!house && !land && (
            <input
              style={{ borderRadius: "10px" }}
              type="text"
              placeholder={isSmall2 ? "ԲՆ. ՀԱՄԱՐ" : "ԲՆԱԿԱՐԱՆԻ ՀԱՄԱՐ"}
              name="roomNumber"
            />
          )}
          <input
            type="tel"
            placeholder={isSmall2 ? "ՏԻՐՈՋ ՀԱՄ." : "ՏԻՐՈՋ ՀԱՄԱՐԸ"}
            name="ownerPhone"
          />
        </div>
        <div className="statusAndSubmit">
          <div className="AStatusOrder">
	  	<AplicationStatus />
	  	<div className="order" style={{ borderRadius: "10px" }}>
	  		<div>
                		<input type="radio" name="in_order" id="order-increase" value="increase" />
                		<label for="order-increase">Ըստ աճման</label>
              		</div>
              		<div>
                		<input type="radio" name="in_order" id="order-decrease" value="decrease" />
                		<label for="order-decrease">Ըստ նվազման</label>
              		</div>
	  	</div>
	  </div>
          {commercial && (
            <div className="commercialType" style={{ borderRadius: "10px" }}>
              <div>
                <input type="radio" name="commercial_type" value="true" />
                <label>Շինության Ներսում</label>
              </div>
              <div>
                <input type="radio" name="commercial_type" value="false" />
                <label>Առանձին Շինության</label>
              </div>
            </div>
          )}
	<div>
	  <select
            className="manorbrok"
            name="broker_id"
            value={brokerId}
            onChange={(e) => setBrokerId(e.target.value)}
          >
            <option value="">գործակալ</option>
            {brokers.map((broker) => (
              <option key={broker.broker_id} value={broker.broker_id}>
                {broker.broker_name} {broker.broker_surname}
              </option>
            ))}
          </select>

          <select
            className="manorbrok"
            name="manager_id"
            value={managerId}
            onChange={(e) => setManagerId(e.target.value)}
          >
            <option value="">մենեջեր</option>
            {managers.map((manager) => (
              <option key={manager.manager_id} value={manager.manager_id}>
                {manager.manager_name} {manager.manager_surname}
              </option>
            ))}
          </select>
	</div>
	  <div>
  <input type="checkbox" id="is_sold" name="is_sold" />
  <label for="is_sold">ՎԱՃԱՌՎԱԾ Է</label>
</div>
          <button
            style={{ cursor: "pointer" }}
            className="submit"
            type="submit"
          >
            ՈՐՈՆԵԼ
          </button>
        </div>
      </div>
    </form>
  );
}
